import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from '../i18n';
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
import authModule from '@/store/auth.js'
import stylesModule from '@/store/styles.js'
import errorsModule from '@/store/errors.js'
import practicasModule from '@/store/practicas.js'
import favoritosModule from '@/store/favoritos.js'
import dominiosModule from '@/store/dominios.js'
import miperfilModule from '@/store/miperfil.js'
import encuestasModule from '@/store/encuestas.js'
import appinfo from '../../package.json';
import messages from '@/translations';

let domain = "https://sandbox-northius.dotia.es/";
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.includes('dev.doubledot.es')){
  domain = "https://sandbox-northius.dotia.es/";
}

export const store = new Vuex.Store({
  state: {
    server: domain,
    language: localStorage.getItem('_idIdiomaPreferido') || 'es',
    showMenu: (window.innerWidth > 1024),
    packageVersion: appinfo.version || '0'
  },
  actions: {
    changeLanguage: ({ commit, dispatch, getters }, nextlang) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', nextlang);

        switch (nextlang) {
          case "es":
            Validator.localize('es', validatorEs);
            break;
          case "ca":
            Validator.localize('ca', validatorCa);
            break;
        }

        if (getters.getLogged) {
          dispatch('requestDominios');
          let lang = { "idIdioma": nextlang };
          axios.post(`api/TutorAcademico/editarIdiomaPreferido`, lang).then(response => {
            window.localStorage.setItem('_idIdiomaPreferido', nextlang);
            resolve(true);
          }).catch(function (error) {
            commit('setError', 500);
            resolve(true);
            dispatch('sendErrorServer', error.response);
          });
        }

        i18n.locale = nextlang;

        resolve(nextlang);
      });
    },
    setMenu: ({ commit }, status) => {
      commit('setStatusMenu', status);
    },
    toggleMenu: ({ commit }) => {
      commit('toggleStatusMenu');
    },

  },
  getters: {
    getLanguage: state => state.language,
    getServer: state => state.server,
    getShowMenu: state => state.showMenu,
    getTexts: state => {
      return messages[state.language];
    },
    getVersion: state => state.packageVersion
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
    },
    setStatusMenu(state, status) {
      state.showMenu = status;
    },
    toggleStatusMenu(state) {
      state.showMenu = !state.showMenu;
    }
  },
  modules: {
    authModule,
    stylesModule,
    errorsModule,
    practicasModule,
    favoritosModule,
    dominiosModule,
    miperfilModule,
    encuestasModule
  }
});


// WEBPACK FOOTER //
// ./src/store/store.js